// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__233Gc","title":"BackImages_title__16LnP","images":"BackImages_images__1Pxwc"};